<script setup>
import { onMounted, useTemplateRef, ref, computed } from "vue";
import { useScrollStore } from "@/stores/storeScroll";
import { useSettingsStore } from "@/stores/storeSettings";
import { useFieldsStore } from "@/stores/storeFieldData";
import { useRequestsStore } from "@/stores/storeRequests";
import { useModals } from "@/utils/useModals";
import { RouterLink, useRoute } from "vue-router";

const { openModal } = useModals();

const storeScroll = useScrollStore();
const storeRequests = useRequestsStore();
const storeSettings = useSettingsStore();
const route = useRoute();

const header = useTemplateRef("header");
const name = ref(null)
const nameWidth = computed(() => name.value?.offsetWidth);
const userName = computed(() => {
	if (storeRequests.userData.first_name === undefined) {
		return "Ваш профиль";
	} else {
		return `${storeRequests.userData?.first_name}`;
	}
});

const isProfilePage = computed(() => route.name === "profile");

const links = {
	main: "Главная",
	// conditions: "Условия",
	prizes: "Призы",
	// faq: "FAQ",
};

const mobileMenuActive = ref(false);

defineProps({
	pageLoaded: {
		type: Boolean,
	},
});

const mobileMenu = () => {
	mobileMenuActive.value = !mobileMenuActive.value;
	if (mobileMenuActive.value) {
		document.body.classList.add("noscroll");
	} else {
		document.body.classList.remove("noscroll");
	}
};

const clickBtnPfofile = () => {
	if (storeSettings.statusSurveyRegistration) {
		openModal("authorization");
	} else {
		openModal("authorization");
	}

	if (storeSettings.statusSurveyFuture) {
		openModal('statusStock', {text: 'Конкурс скоро будет доступен.', btn: false});
	}

	// if (storeSettings.statusSurveyFinal) {
	// 	openModal('statusStock', {text: 'Акция завершенa.', btn: false});
	// }
	
};

onMounted(() => {
	storeScroll.header = header.value;
});
</script>
<template>
	<div @click="mobileMenu" id="overlay" :class="{ active: mobileMenuActive }"></div>
	<div @click="mobileMenu" :class="['mobile-menu', { active: mobileMenuActive }]">
		<div class="header__links">
			<nav class="nav">
				<template v-for="(label, link) in links" :key="link">
					<RouterLink :to="`/#${link}`" class="nav__link">
						{{ label }}
					</RouterLink>
				</template>
			</nav>
            <div class="header__profile-btns">
				<button class="btn-user --underline" v-if="!storeRequests.isAuthenticated" @click="clickBtnPfofile">
					<span>Войти</span>
				</button>
				<RouterLink class="btn-user --underline" to="/profile" v-else>
					<span>Профиль</span>
				</RouterLink>
				<button v-if="storeRequests.isAuthenticated" @click="storeRequests.logout()" class="btn-logout">
					Выйти
				</button>
			</div>
		</div>
	</div>
	<header :class="['header', isProfilePage, { 'header--fixed': storeScroll.headerFixed }, { active: mobileMenuActive }]" ref="header">
		<div class="container --big">
			<div class="header__container">
				<!-- <div class="header__logo">
					<RouterLink to="/" class="logo">
						<img loading="lazy" width="243" height="48" src="@/assets/img/logo.svg" alt="логотип" />
					</RouterLink>
				</div> -->
				<div class="header__links">
					<nav class="nav">
						<template v-for="(label, link) in links" :key="link">
							<RouterLink :to="`/#${link}`" class="nav__link">
								{{ label }}
							</RouterLink>
						</template>
					</nav>
					<div class="header__profile-btns">
						<button class="btn-user --underline" v-if="!storeRequests.isAuthenticated" @click="clickBtnPfofile">
							<span>Войти</span>
						</button>
						<RouterLink class="btn-user --underline" to="/profile" v-else>
							<span>Профиль</span>
						</RouterLink>
						<button v-if="storeRequests.isAuthenticated" @click="storeRequests.logout()" class="btn-logout">
							Выйти
						</button>
					</div>
				</div>
				<div @click="mobileMenu" :class="['nav-icon', { active: mobileMenuActive }]"><span></span></div>
			</div>
		</div>
	</header>
</template>
<style lang="scss" scoped>
@use "@/assets/scss/blocks/nav-icon";
@use "@/assets/scss/blocks/mobile-menu";
@use "@/assets/scss/base/vars";

.header {
	position: sticky;
	width: 100%;
	top: 0px;

	z-index: 4;
	background-color: #fff;
	transition: 0.2s ease-in;

	&.header--fixed {
		.header__container {
			padding: 1.6rem 1rem;
			@media (max-width: vars.$m) {
				padding: 1.2rem 0px 1rem;
			}
			@media (max-width: vars.$x480) {
				padding: 1.2rem 1.5rem 1rem;
				margin: 0 -1rem;
			}
		}
		.logo {
			width: 17rem;
			@media (max-width: vars.$x480) {
				width: 14.8rem;
			}
		}
	}
}

.header__container {
	display: flex;
	align-items: center;
	justify-content: space-between;
	justify-content: end;
	gap: 1rem;
	padding: 2.4rem 1rem;
	border-bottom: 1px solid #d6d6d6;
	transition: 0.2s ease-in;
	@media (max-width: vars.$m) {
		padding: 1.2rem 0px 1rem;
	}
	@media (max-width: vars.$x480) {
		padding: 1.2rem 1.5rem 1rem;
		margin: 0 -1rem;
	}
}

.logo {
	display: block;
	width: 22.4rem;
	@media (max-width: vars.$m) {
		width: 17rem;
	}
	@media (max-width: vars.$x480) {
		width: 14.8rem;
	}
}

.header__links {
	display: flex;
	align-items: center;
	gap: 10rem;

	font-weight: 400;
	font-size: 1.5rem;
	line-height: 130%;
	@media (max-width: vars.$m) {
		display: none;
	}
}
.nav {
	display: flex;
	align-items: center;
	gap: 3rem;
}
.nav__link {
	color: var(--black);

	@media (hover: hover) {
		&:hover {
			color: var(--red);
		}
		
	}
}
.header__profile-btns {
	display: flex;
	align-items: center;
	gap: 1.6rem;
}
.header__select {
	position: relative;
	z-index: 1;
	@media (hover: hover){
		&:hover {			
			.header__select-box {
				opacity: 1;
				pointer-events: all;
			}
		}
	}
}
.header__select-box {
	position: absolute;
	display: grid;
	top: -13px;
	left: 50%;
	transform: translateX(-50%);
	gap: 12px;
	justify-content: center;
    padding: 45px 18px 16px;
	box-shadow: 0 0 19px 0 rgba(0, 0, 0, 0.14);
	background: var(--white);
	opacity: 0;
	pointer-events: none;
	transition:  var(--transition) ease-in;
}
.btn-user-link {
	font-weight: 400;
	font-size: 1.6rem;
	line-height: 130%;
	color: var(--black);
}
.btn-user {
	position: relative;
    z-index: 1;
	display: flex;
	align-items: center;
	gap: .6rem;
	color: var(--red);
	span {
		max-width: 17.2rem;
		text-overflow: ellipsis;
		white-space: nowrap;
		overflow: hidden;
		svg {
		}
	}
	&.--underline {
		span {
			border-bottom: 1px solid currentColor;
		}
	}
    @media (max-width: vars.$m) {
        font-weight: 600;
		font-size: 28px;
		line-height: 130%;
		text-transform: uppercase;
    }
	@media (hover: hover){
		&:hover {			
			
		}
	}
}
.btn-logout {
	color: rgba(29, 29, 27, 0.5);
	@media (hover: hover) {
		&:hover {
			
			color: var(--red);
		}
	}
}

@keyframes animHeader {
	0% {
		transform: translateY(-100%);
		// opacity: 0;
	}
	100% {
		transform: translateY(0%);
		// opacity: 1;
	}
}
</style>
